import React from "react";
import { Global, css } from "@emotion/react";
import { space } from "../design-system/tokens";

const GlobalStyle = (props) => (
  <Global
    {...props}
    styles={css`
      html,
      body,
      #root {
        height: 100%;
      }

      body {
        margin: 0;
      }

      .MuiCardHeader-action .MuiIconButton-root {
        padding: ${space["1"]};
        width: 28px;
        height: 28px;
      }
    `}
  />
);

export default GlobalStyle;
